import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  customer: Yup.object().shape({
    name: Yup.object().nullable().required('Customer Name is required'),
    passengers: Yup.number().nullable().required('Passengers is required'),
  }),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
